import { MDBRow, MDBCol, MDBIcon, MDBBtn } from 'mdb-react-ui-kit';
import ScrollTo from "react-scroll-into-view";
import { motion } from "framer-motion";

const SectionOne = ({sectionId, sectionSelector}) => {


  return (
    
        <MDBRow id={sectionId} className="row d-flex justify-content-center align-items-center section-bg-black section-full-frame" >
            <MDBCol className="col-sm-12 text-center d-flex flex-column justify-content-center align-items-center align-self-stretch mb-0 black p-5">
                <span className="section-font-color">TURPIS BIBENDUM</span>
                <motion.div initial={{ opacity: 0, x:-200 }} whileInView={{  opacity: 1, x:0}}  transition={{ delay: 0.2 }} >
                
                <h1 className="display-1 font-weight-bold my-4 section-font text-center section-font-color">AMET DUIS <br/>ULTRICIES</h1>
                </motion.div>
                <h4 className="text-white w-50">Ullamcorper morbi tincidunt ornare eget purus viverra. Massa placerat duis ultricies lacus sed turpis sit fulminare lorem ipsum dolor sit amet consequat adipiscing.</h4>
                <ScrollTo selector={sectionSelector}>
                    <MDBBtn rounded className="p-3 my-4 d-flex justify-content-center align-items-center section-btn section-bg-yellow">
                    <h5 className="text-black mt-2 ms-3">MASSA ALIQUAM</h5> <MDBIcon fas icon="arrow-down" size='2x' className="text-black ms-3 me-4"/>
                    </MDBBtn>
                </ScrollTo>   
            </MDBCol>
        </MDBRow>

  )
}

export default SectionOne